/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MinInputs */

const en_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const ar_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دقيقة`)
};

const de_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min.`)
};

const es_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const fr_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const it_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const ja_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const ko_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분`)
};

const pt_br_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const ru_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мин.`)
};

const th_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นาที`)
};

const tr_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dk`)
};

const zh_cn_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟`)
};

const zh_tw_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分鐘`)
};

/**
* | output |
* | --- |
* | "min" |
*
* @param {MinInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const min = /** @type {((inputs?: MinInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MinInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_min(inputs)
	if (locale === "ar") return ar_min(inputs)
	if (locale === "de") return de_min(inputs)
	if (locale === "es") return es_min(inputs)
	if (locale === "fr") return fr_min(inputs)
	if (locale === "it") return it_min(inputs)
	if (locale === "ja") return ja_min(inputs)
	if (locale === "ko") return ko_min(inputs)
	if (locale === "pt_br") return pt_br_min(inputs)
	if (locale === "ru") return ru_min(inputs)
	if (locale === "th") return th_min(inputs)
	if (locale === "tr") return tr_min(inputs)
	if (locale === "zh_cn") return zh_cn_min(inputs)
	return zh_tw_min(inputs)
});